import { render, staticRenderFns } from "./PopSuggestion.vue?vue&type=template&id=464a127a"
import script from "./PopSuggestion.vue?vue&type=script&lang=js"
export * from "./PopSuggestion.vue?vue&type=script&lang=js"
import style0 from "./PopSuggestion.vue?vue&type=style&index=0&id=464a127a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports